import DateObject from "react-date-object";

const TimeSince = (date) => {
  let dateObject = new DateObject();
  dateObject._format = "DD/MM/YYYY hh:mm:ss";
  const seconds = (new Date().getTime() - dateObject.parse(date)) / 1000
  let interval = seconds / 31536000
  if (interval >= 1) {
    return Math.floor(interval) + " ann" + (interval >= 2 ? "i" : "o")
  }
  interval = seconds / 2592000;
  if (interval >= 1) {
    return Math.floor(interval) + " mes" + (interval >= 2 ? "i" : "e")
  }
  interval = seconds / 86400;
  if (interval >= 1) {
    return Math.floor(interval) + " giorn" + (interval >= 2 ? "i" : "o")
  }
  interval = seconds / 3600;
  if (interval >= 1) {
    return Math.floor(interval) + " or" + (interval >= 2 ? "e" : "a")
  }
  interval = seconds / 60;
  if (interval >= 1) {
    return Math.floor(interval) + " minut" + (interval >= 2 ? "i" : "o")
  }
  return Math.floor(seconds) + " second" + (interval >= 2 ? "i" : "o")
}

export default TimeSince